import React, { createContext, useReducer } from "react";

const initialState = {
    loading: true,
    loadingTeam: true,
    loadingInvitedTeammates: true,
    isAdmin: false,
    permissionOptions: {},
    teamData: [],
    invited: [],
    inFlight: false,
};

const teamReducer = (state = initialState, action) => {
    switch (action.type) {
        case "REQUEST_START":
            return { ...state, inFlight: true };

        case "REQUEST_END":
            return { ...state, inFlight: false };
        
        case "FETCH_PERMISSIONS":
            const newState1 = { ...state };
            newState1['isAdmin'] = action.payload.data.is_admin;
            newState1['permissionOptions'] = action.payload.data.permission_options;
            newState1['teamData'] = action.payload.data.team_permissions;
            newState1['loadingTeam'] = false;
            return newState1;

        case "FETCH_TEAM":
            const newState2 = { ...state };
            newState2['loading'] = false;
            newState2['companyData'] = action.payload.data;
            return newState2;

        case "INVITE_TEAMMATE":
            const { newTeamData } = action.payload;
            const newState = { ...state, inFlight: false };
            newState['invited'] = [...newState.invited, ...newTeamData];
            return newState;
                
        case "DELETE_TEAMMATE":
            const { teamMateMail } = action.payload;

            const newState3 = { ...state, inFlight: false };
            newState3.teamData = newState3.teamData.filter((teamMate) => teamMate.email.indexOf(teamMateMail) === -1);

            return newState3;
        
        case "DELETE_INVITED_TEAMMATE":
            const { invitedTeamMate } = action.payload;

            const newState4 = { ...state, inFlight: false };
            newState4.invited = newState4.invited.filter((teamMate) => teamMate.email.indexOf(invitedTeamMate) === -1);

            return newState4;

        case "UPDATE_PERMISSIONS":
            const { permissions } = action.payload;
            const newState5 = { ...state };
            const updatedTeamData = [...newState5.teamData];
            
            for(var i=0; i<updatedTeamData.length; i++){
                if((updatedTeamData[i].email === permissions.email)){
                    updatedTeamData[i]['permissionId'] = permissions.permission_id_to;
                }
            }
            newState5['teamData'] = updatedTeamData;
            
            return newState5;
        
        case "UPDATE_TXNSLIMIT":
            const { txnLimit } = action.payload;
            const newState6 = { ...state, inFlight: false };
            const updatedTeamTxnLimitData = [...newState6.teamData];
            
            for(var i=0; i<updatedTeamTxnLimitData.length; i++){
                if((updatedTeamTxnLimitData[i].email === txnLimit.email)){
                    updatedTeamTxnLimitData[i]['transaction_threshold']['txn_limit'] = txnLimit.txn_limit;
                }
            }
            newState6['teamData'] = updatedTeamTxnLimitData;
            
            return newState6;

            case "FETCH_INVITED_PAGE":
                const newState7 = { ...state };
                let newList = [...newState7.invited];
                action.payload.data.forEach(item => {
                    const index = newList.findIndex(existingItem => existingItem.id === item.id);
                    if (index !== -1) {
                        newList[index] = item;
                    } else {
                        newList.push(item);
                    }
                });
                newState7['invited'] = newList;
                newState7['loadingInvitedTeammates'] = false;
                return newState7;

        default:
            return state;
    }
};

const useThunkReducer = (reducer, initialState) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const enhancedDispatch = React.useCallback(
        (action) => {
            if (typeof action === "function") {
                action(dispatch);
            } else {
                dispatch(action);
            }
        },
        [dispatch]
    );

    return [state, enhancedDispatch];
};

export const TeamContext = createContext();

export const TeamProvider = ({ children }) => {
    const [state, dispatch] = useThunkReducer(teamReducer, initialState);

    return (
        <TeamContext.Provider value={{ state, dispatch }}>
            {children}
        </TeamContext.Provider>
    );
};
